import { render, staticRenderFns } from "./Detail-Payroll.vue?vue&type=template&id=39b56060"
import script from "./Detail-Payroll.vue?vue&type=script&lang=js"
export * from "./Detail-Payroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports